import apiService from './apiService';
import { API_ENDPOINTS } from '../constants/apiConstants';

export const footerAPI = {
  getFooter: async () => {
    const response = await apiService.get(API_ENDPOINTS.AUTH.GET_CONTACT);
    return response.data;
  },
  updateFooter: async (data: {
    address?: string;
    mobileno?: string;
    instagramlink?: string;
    facebooklink?: string;
    twitterlink?: string;
    description?: string;
  }) => {
    const response = await apiService.put(API_ENDPOINTS.AUTH.UPDATE_PROFILE, data);
    return response.data;
  },
};